import { render, staticRenderFns } from "./CopyKaTemplateModal.vue?vue&type=template&id=cc92544c&scoped=true"
import script from "./CopyKaTemplateModal.vue?vue&type=script&lang=ts"
export * from "./CopyKaTemplateModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyKaTemplateModal.vue?vue&type=style&index=0&id=cc92544c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc92544c",
  null
  
)

export default component.exports